(function () {
    'use strict';
    angular.module('Directives').directive('sidebarMenu', sidebarMenu);
    sidebarMenu.$injecct = [
        '$route',
        'PermissionHelpers',
        '$location',
        '$rootScope',
        'AdminPermissionService',
        '$q'
    ];

    function sidebarMenu(
        $route,
        PermissionHelpers,
        $location,
        $rootScope,
        AdminPermissionService,
        $q
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/sidebar-menu.html',
            replace: true,
            scope: {
                company: '=',
                roles: '='
            },
            link: sidebarMenuLink,
        }

        function sidebarMenuLink($scope) {
            $scope.mainMenu = [];
            $scope.currentRouteParams = {};
            $scope.moduleAccess = [];

            $scope.isParentActive = isParentActive;
            $scope.isSubActive = isSubActive;

            init();

            function init() {
                getModulePermissions().then(() => {
                    createMenus();
                    setDefaultActiveMenu();
                    initRouteChangeListener();
                });
            }

            function getModulePermissions() {
                const defer = $q.defer();
                AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                    success.content.forEach(user => {
                        user.modules.forEach(module => {
                            $scope.moduleAccess.push(module.name);
                        });
                    });
                    defer.resolve($scope.moduleAccess);
                }, error => {
                }, $rootScope.GlobalProfile.id);
                return defer.promise;
            }

            function createMenus() {
                const moduleAccess = PermissionHelpers.getModuleAccess($scope.roles, $scope.moduleAccess);

                for (let i in $route.routes) {
                    const route = $route.routes[i];
                    if (!route.params || !route.params.mainMenu) { continue; }
                    
                    if (moduleAccess.length > 0) {
                        if (moduleAccess.find(item => item === route.params.itemText)) {
                            if (PermissionHelpers.isHideRatesEngine($scope.moduleAccess) && route.params.name === 'carriers') {
                                const routeSubMenu = angular.copy(route.params.subMenus);
                                // route.params.subMenus = routeSubMenu.filter(r => r.name !== 'serviceProfiles' && r.name !== 'fuelLevies');
                                route.params.subMenus = routeSubMenu.filter(r => r.name !== 'fuelLevies');
                            }
                            $scope.mainMenu.push(route);
                        }
                        continue;
                    }

                    $scope.mainMenu.push($route.routes[i]);
                }
            }

            function setDefaultActiveMenu() {
                const currentUrl = $location.url().split(/[?\/,]+/)[1];
                const routeData = $scope.mainMenu.find(rData => angular.getObjVal(rData, 'originalPath').includes(currentUrl));

                $rootScope.currentRouteParams = angular.getObjVal(routeData, 'params') || {};
                $scope.currentRoute = routeData
                $scope.currentUrl = $location.url();
            }

            function initRouteChangeListener() {
                $scope.$on('$routeChangeSuccess', routeChangeListener);
            }

            function routeChangeListener(event, current) {
                activateMenu(current);
            }

            function activateMenu(currentRoute) {
                $scope.currentRoute = currentRoute.$$route;
                $scope.currentUrl = $location.url();
                $rootScope.currentRouteParams = $scope.currentRoute.params;
            }

            function isParentActive(route) {
                if (!route
                    || !angular.getObjVal(route, 'params')
                    || !angular.getObjVal(route, 'params.name')) {
                    return false;
                }

                const isActive = route.params.name.indexOf($rootScope.currentRouteParams.parent) > -1;
                return isActive;
            }

            function isSubActive(subMenu) {
                const isActive = (subMenu.url.trim() === $scope.currentUrl ? $scope.currentUrl.split('?')[0] : false)
                    || subMenu.url.trim() === $scope.currentUrl
                    || angular.getObjVal($rootScope.currentRouteParams, 'subParent') === subMenu.name
                    || $scope.currentUrl.includes(subMenu.url);

                return !!isActive;
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/sideBarMenu.js